import Blog from "../Pages/Blog/Blog";
import ProjectDetails from "../Pages/Sections/Projects/ProjectDetails";

const { createBrowserRouter } = require("react-router-dom");
const { default: Root } = require("../Layout/Root/Root");
const { default: Home } = require("../Pages/Home/Home");

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Root></Root>,
    children: [
      {
        path: "/",
        element: <Home></Home>,
      },
      {
        path: "/home",
        element: <Home></Home>,
      },
      {
        path: "/blog",
        element: <Blog></Blog>,
      },
      {
        path: "/project/:id",
        element: <ProjectDetails></ProjectDetails>,
        loader: ({ params }) =>
          fetch(`https://myportfolio1-server.vercel.app/project/${params.id}`),
      },
    ],
  },
]);
